import { Alert } from "antd";
import { useTranslation } from "react-i18next";

const ErrorBanner = ({ errors, onClose }) => {
  const { t } = useTranslation();

  if (!errors?.length) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 1000,
        padding: "8px 16px",
      }}
    >
      <Alert
        message={t("error_banner_title")}
        description={
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {errors.map((err, idx) => (
              <li key={idx}>{err}</li>
            ))}
          </ul>
        }
        type="error"
        closable
        onClose={onClose}
        showIcon
      />
    </div>
  );
};

export default ErrorBanner;
